/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import { Button, Dialog, DialogContent, DialogTitle, LinearProgress } from '@mui/material';
import Grid from '@mui/material/Grid';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CloseIcon from '@mui/icons-material/Close';
import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { appendWafSafeFormField } from '../common/common';
import { editServiceManualEndPoint, uploadServiceManualEndPoint } from '../common/constants';
import { loadFromLocalStorage } from '../common/localStorage';
import logo from '../images/blueLogo.svg';
import icAdd from '../images/ic-add.svg';
import { actionCreators } from '../store/UploadManual';
import DragDrop from './DragDrop';
import './styles.css';
import UploadSteps from './UploadSteps';


interface Props {
    UpdateSelectedPdf: Function
    clearAll: Function
    displayName: any
    selectedPdf: any
    selectedProductModels: any
    serviceManualPartNo: any
    revision: any
    documentCategory: any
    releaseDate: any
    helpLinkAssignments: any
    uploadDialogOpen: boolean
    isEdit?: boolean
    handleUploadDialogClick: Function
    originalProductModels: any
    fileName: any
    UpdateFileName: Function
    isFileChanged: boolean
}
interface State {
    step: number
    isFormSubmitted: boolean
    isUploading: boolean
    isSuccess: boolean
    isFailure: boolean
}
class Upload extends React.Component<Props, State> {

    state = {
        step: 1,
        isFormSubmitted: false,
        isUploading: false,
        isSuccess: false,
        isFailure: false
    };
    handleClickOpen = () => {
        this.props.handleUploadDialogClick(true);
    };

    handleClose = () => {
        this.props.clearAll();
        this.props.handleUploadDialogClick(false);
    };
    onDrop = async (selectedPdf: any, fileName: any) => {
        await this.props.UpdateFileName(`${fileName}`);
        this.props.UpdateSelectedPdf(selectedPdf);
    };
    handleSubmit = async () => {
        const helpButtonPageNumberMapping = [];
        if (this.props.helpLinkAssignments !== undefined) {
            for (const key of Object.keys(this.props.helpLinkAssignments)) {
                if (this.props.helpLinkAssignments[key] != null && !isNaN(this.props.helpLinkAssignments[key])) {
                    console.log(this.props.helpLinkAssignments[key]);
                    helpButtonPageNumberMapping.push({
                        helpbuttonid: parseInt(key), pagenumber: this.props.helpLinkAssignments[key]
                    });
                }
            }
        }
        const uploadRequest = new FormData();
        appendWafSafeFormField(uploadRequest, 'filename', `${this.props.fileName}`, 'FileNameEncoding');
        uploadRequest.append('displayname', `${this.props.displayName}`);
        const isEditApi: boolean = this.props.isEdit || this.props.isFileChanged;
        if (!this.props.isEdit || this.props.isFileChanged) {
            uploadRequest.append('formfile', this.props.selectedPdf);
        }
        uploadRequest.append('servicemanualpartnumber', this.props.serviceManualPartNo === undefined ||
            this.props.serviceManualPartNo === null ? '' : this.props.serviceManualPartNo);
        uploadRequest.append('revision', this.props.revision === undefined || this.props.revision === null ? '' : this.props.revision);
        uploadRequest.append('version', '1');
        uploadRequest.append('servicemanualtypeid', this.props.documentCategory);
        uploadRequest.append('HelpDocumentTypeId', JSON.stringify(1));
        appendWafSafeFormField(
            uploadRequest,
            'dateofissue',
            (this.props.releaseDate != null && this.props.releaseDate !== undefined) ? this.props.releaseDate.toJSON() : '',
            'DateOfIssueEncoding');
        appendWafSafeFormField(
            uploadRequest,
            'helpButtonPageNumberMapping',
            JSON.stringify(helpButtonPageNumberMapping),
            'HelpButtonMappingEncoding');
        if (isEditApi) {
            const addedModels: any = this.props.selectedProductModels.filter((x: any) => {
                return this.props.originalProductModels.indexOf(x) < 0;
            });
            const removedModels: any = this.props.originalProductModels.filter((x: any) => {
                return this.props.selectedProductModels.indexOf(x) < 0;
            });
            uploadRequest.append('addedtwodmodelidlist', JSON.stringify(addedModels));
            uploadRequest.append('removedtwodmodelidlist', JSON.stringify(removedModels));
            uploadRequest.append('isfilechanged', JSON.stringify(this.props.isFileChanged));
        }
        else {
            uploadRequest.append('twodmodelidlist', JSON.stringify(this.props.selectedProductModels));
        }
        const token: string = loadFromLocalStorage('AuthToken');
        const encodedToken = 'Bearer ' + token;
        const headerDict: any = {
            'Authorization': encodedToken,
        };
        this.setState({ isFormSubmitted: true, isUploading: true });
        const response = await fetch(isEditApi ? editServiceManualEndPoint : uploadServiceManualEndPoint, {
            headers: new Headers(headerDict),
            body: uploadRequest,
            method: 'POST'
        });
        this.setState({ isUploading: false });
        const responseData = response.status;
        if (response.status === 201 || response.status === 200) {
            this.setState({ isSuccess: true }, () => {
                setTimeout(() => {
                    window.location.reload();
                    this.setState({ isSuccess: false });
                }, 5000);
            });
        }
        else {
            this.setState({ isFailure: true }, () => {
                setTimeout(() => {
                    this.setState({
                        isFormSubmitted: false, isFailure: false
                    });
                }, 5000);
            });
        }
    };
    render() {
        const { isFormSubmitted, isUploading, isSuccess, isFailure } = this.state;
        const { isEdit, uploadDialogOpen } = this.props;
        return (
            <div>

                {!isEdit && <Button id="upload-button" onClick={this.handleClickOpen}>
                    <Grid container justifyContent="space-evenly">
                        <img src={icAdd}
                            className="ic_add" />
                        <span className="uploadButtonText">Upload</span>
                    </Grid>
                </Button>
                }
                <Dialog
                    fullScreen
                    className="UploadDialog"
                    open={uploadDialogOpen}
                    onClose={this.handleClose}
                >
                    <DialogTitle className="dialogTitle">
                        <Grid container justifyContent="space-between">

                            <span>
                                <img src={logo}
                                />
                                <span className="boldFont uploadTitle">Service Manual Upload</span>
                            </span>

                            {(!isUploading) &&
                                <CloseIcon onClick={this.handleClose} style={{ cursor: 'pointer' }} />}

                        </Grid>
                    </DialogTitle>
                    <DialogContent className="uploadDialogContent">
                        {!isFormSubmitted &&
                            <Grid container className="uploadGrid">
                                <Grid className="dragdrop">
                                    <DragDrop onDrop={this.onDrop} selectedPdf={this.props.selectedPdf} />
                                </Grid>
                                <UploadSteps handleSubmit={this.handleSubmit} />
                            </Grid>
                        }

                        {isUploading &&
                            <Grid className="uploadDialogMessages">
                                <Grid container justifyContent="center">
                                    Uploading...
                                </Grid>
                                <Grid>
                                    <LinearProgress className="uploadprogress" />
                                </Grid>
                            </Grid>
                        }
                        {isSuccess &&
                            <Grid>

                                <Grid container justifyContent="center">
                                    <Grid>
                                        <CheckCircleOutlineIcon className="uploadSuccess" />
                                    </Grid>
                                </Grid>
                                <Grid container justifyContent="center">
                                    Upload Successful. Redirecting...
                                </Grid>
                            </Grid>
                        }
                        {isFailure &&
                            <Grid className="uploadDialogMessages" container justifyContent="center">
                                There was an error while uploading. Please try again later...
                            </Grid>
                        }

                    </DialogContent>
                </Dialog>
            </div>
        );
    }
}

const mapStateToProps = (state: any) => ({
    state: state.uploadManual,
    revision: state.uploadManual.revision,
    serviceManualPartNo: state.uploadManual.serviceManualPartNo,
    displayName: state.uploadManual.displayName,
    releaseDate: state.uploadManual.releaseDate,
    documentCategory: state.uploadManual.documentCategory,
    selectedPdf: state.uploadManual.selectedPdf,
    selectedProductModels: state.uploadManual.selectedProductModels,
    helpLinkAssignments: state.uploadManual.helpLinkAssignments,
    uploadDialogOpen: state.uploadManual.uploadDialogOpen,
    originalProductModels: state.uploadManual.originalProductModels,
    fileName: state.uploadManual.fileName,
    isFileChanged: state.uploadManual.isFileChanged,
    isEdit: state.uploadManual.isEdit
});

const mapDispatchtoProps = (dispatch: any) =>
    bindActionCreators(actionCreators, dispatch);

export default connect(
    mapStateToProps, mapDispatchtoProps
)
    (Upload);
